/**
 * Single source for patient testimonials (homepage + procedure pages).
 * All entries are five-star reviews. Copy is kept concise for card layouts.
 */
export const ALL_TESTIMONIALS = [
  {
    id: 13,
    name: "Payal K.",
    procedure: "Lipoma",
    source: "Google",
    text: "Excellent care for my axillary lipoma—clear expectations and post-op follow-up. I recommend Dr. Jain without hesitation.",
    rating: 5,
  },
  {
    id: 15,
    name: "Manas C.",
    procedure: "Plastic Surgery",
    source: "Google",
    text: "Professional, caring, and clear at every step. Recovery went smoothly. Highly recommended.",
    rating: 5,
  },
  {
    id: 14,
    name: "Dikshit U.",
    procedure: "Lipoma",
    source: "Google",
    text: "Clean, welcoming clinic and a smooth lipoma procedure—knowledgeable, thorough, and great results.",
    rating: 5,
  },
  {
    id: 11,
    name: "Suraj P.",
    procedure: "Gynecomastia",
    source: "Google",
    text: "Gynecomastia with Dr. Vicky Jain was life-changing—natural results and real confidence. A skilled, compassionate surgeon.",
    rating: 5,
  },
  {
    id: 12,
    name: "Chintan V.",
    procedure: "Gynecomastia",
    source: "Google",
    text: "Results matched what I wanted—a flat chest. Very supportive before and after surgery. Highly recommend.",
    rating: 5,
  },
  {
    id: 1,
    name: "Priya M.",
    procedure: "Rhinoplasty",
    source: "Practo",
    text: "Technical skill with genuine care—every step explained. Results exceeded my expectations; I feel much more confident.",
    rating: 5,
  },
  {
    id: 2,
    name: "Rahul S.",
    procedure: "Gynecomastia",
    source: "Practo",
    text: "Clear on pros and cons, very happy with results, and excellent post-op follow-up and medication guidance.",
    rating: 5,
  },
  {
    id: 3,
    name: "Anita K.",
    procedure: "Burn Reconstruction",
    source: "Practo",
    text: "After my son’s burn injury, Dr. Jain’s calm expertise reassured us—patient explanations at every step.",
    rating: 5,
  },
  {
    id: 4,
    name: "Suresh D.",
    procedure: "Diabetic Foot",
    source: "Eka Care",
    text: "Foot healed in weeks after months elsewhere—clear guidance that eased my fear of amputation.",
    rating: 5,
  },
  {
    id: 5,
    name: "Rashmi V.",
    procedure: "Lipoma Surgery",
    source: "Eka Care",
    text: "Professional lipoma care from day one—knowledgeable, reassuring, and attentive through recovery.",
    rating: 5,
  },
  {
    id: 6,
    name: "Meera T.",
    procedure: "Tendon Surgery",
    source: "Practo",
    text: "Excellent tendon surgery and follow-up—made a stressful time manageable. Highly recommend.",
    rating: 5,
  },
  {
    id: 7,
    name: "Vikram N.",
    procedure: "Wrist Surgery",
    source: "Eka Care",
    text: "Genuine and educational—no scare tactics. Stitches and recovery went smoothly.",
    rating: 5,
  },
  {
    id: 8,
    name: "Deepa R.",
    procedure: "Cosmetic Consultation",
    source: "Practo",
    text: "Took time to listen; I left informed and confident. Excellent consultation.",
    rating: 5,
  },
  {
    id: 9,
    name: "Arjun P.",
    procedure: "Gynecomastia",
    source: "HexaHealth",
    text: "Caring and reachable post-op—understand why so many patients recommend Dr. Jain.",
    rating: 5,
  },
  {
    id: 10,
    name: "Sonal B.",
    procedure: "Facelift",
    source: "Justdial",
    text: "Natural results and a professional team—supportive staff and thorough follow-up.",
    rating: 5,
  },
  {
    id: 101,
    name: "Priya S.",
    procedure: "Rhinoplasty",
    source: "Patient review",
    text: "Natural, beautiful results—exactly what I wanted. My confidence has transformed.",
    rating: 5,
  },
  {
    id: 102,
    name: "Rahul M.",
    procedure: "Reconstructive Surgery",
    source: "Patient review",
    text: "After my accident, Dr. Jain gave me my life back—unmatched skill and compassion.",
    rating: 5,
  },
  {
    id: 103,
    name: "Anjali K.",
    procedure: "Non-Surgical Treatment",
    source: "Patient review",
    text: "Refreshed and natural—subtle results exactly as I hoped.",
    rating: 5,
  },
];

export function initialsFromDisplayName(name) {
  const cleaned = name.replace(/\./g, " ").trim();
  const parts = cleaned.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return (parts[0] || "?").slice(0, 2).toUpperCase();
}
